import moment from 'moment'
import React from 'react'
import DefaultCell from '../../../../../components/TableElements/CustomCells/DefaultCell'
import PaymentCell from '../../../../../components/TableElements/CustomCells/PaymentCell'
import StatusCell from '../../../../../components/TableElements/CustomCells/StatusCell'
import { RequestType } from '../../../components/SingleRequest/types/Request.type'
import { CategoriesResponse } from '../types/types'
import { formatSelectedCategories } from './formatSelectedCategories'
import { formatAddress, formatName, formatPhoneNumber } from './ordersUtiles'
import { mapPaymentTypes } from './payment-types'
import { mapRequestsStatuses } from './requests-statuses'

interface CellContentProps {
  key: string
  element: RequestType
  index: number
  categories?: CategoriesResponse
}

const getCellStyles = (index: number) => ({
  backgroundColor:
    index % 2 !== 0 ? 'rgba(217, 217, 217, 0.20)!important' : undefined,
})

export const getCorrectValue = (
  key: string,
  element: RequestType,
  categories?: CategoriesResponse
) => {
  let value = element[key as keyof RequestType]

  if (['dateOfMaintenance', 'created'].includes(key)) {
    value = value ? moment(value as string).format('DD.MM.YYYY') : '-'
  }

  if (key === 'locality') value = formatAddress(element, false)
  if (key === 'name') value = formatName(element)
  if (key === 'phone') value = formatPhoneNumber(element.phone ?? '') || '-'
  if (key === 'categories')
    value = formatSelectedCategories(element[key], categories)

  return key === 'id' ? String(value).padStart(6, '0') : value
}

export const getCellContent = ({
  key,
  element,
  index,
  categories,
}: CellContentProps) => {
  const styles = getCellStyles(index)
  const value = getCorrectValue(key, element, categories)

  if (key === 'status') {
    const src = (mapRequestsStatuses as any)[element.status]?.imageSrc
    const tooltipName = (mapRequestsStatuses as any)[element.status]?.name

    return (
      <StatusCell
        tooltipName={tooltipName}
        src={src ?? ''}
        backgroundColor={styles.backgroundColor}
        key={key}
      />
    )
  }

  if (key === 'financialSourceId') {
    const src = (mapPaymentTypes as any)[element.financialSourceId ?? -1]
      ?.imageSrc
    const tooltipName = (mapPaymentTypes as any)[
      element.financialSourceId ?? -1
    ]?.name
    return (
      <PaymentCell
        src={src}
        tooltipName={tooltipName}
        backgroundColor={styles.backgroundColor}
        key={key}
      />
    )
  }

  return (
    <DefaultCell
      value={value}
      backgroundColor={styles.backgroundColor}
      key={key}
      withCopyIcon={key === 'id'}
      withTooltip={key === 'locality'}
    />
  )
}
